/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import ReactApexChart from 'react-apexcharts'
import { ApexOptions } from 'apexcharts'
import { useCustomTheme } from '../../../../context/Theme/ThemeContextData'

interface Props {
  data: any[]
  isVolumeMode?: boolean
}

export const FamilyRevenueChart: React.FC<Props> = ({ data = [], isVolumeMode = true }) => {
  const { theme } = useCustomTheme()
  const isLight = theme === 'light'

  const series = [
    {
      name: isVolumeMode ? 'Volume (CX)' : 'Faturamento (R$)',
      data: data.map((i) => Number(Number(i.total).toFixed(2))),
    },
  ]

  const categories = data.map((i) => i.name)

  const options: ApexOptions = {
    chart: { type: 'bar', toolbar: { show: false } },
    plotOptions: { bar: { borderRadius: 4, horizontal: true, barHeight: '70%' } },
    colors: ['#a6c10b'],
    xaxis: {
      categories: categories,
      labels: { style: { colors: isLight ? '#475569' : '#fff' } },
    },
    yaxis: {
      labels: {
        style: {
          colors: isLight ? '#1e293b' : '#fff',
          fontSize: '11px',
          fontWeight: isLight ? 600 : 400,
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val: number) =>
        isVolumeMode ? `${val.toFixed(1)} CX` : `R$ ${val.toLocaleString('pt-BR')}`,
      style: {
        fontSize: '10px',
        colors: [isLight ? '#0f172a' : '#fff'],
        fontWeight: isLight ? 700 : 400,
      },
      offsetX: 10,
    },
    grid: { borderColor: isLight ? '#e2e8f0' : '#334155' },
    tooltip: {
      theme: isLight ? 'light' : 'dark',
      y: {
        formatter: (val: number) =>
          isVolumeMode
            ? `${val.toFixed(1)} CX`
            : `R$ ${val.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
      },
    },
    noData: { text: 'Nenhum dado para exibir', style: { color: isLight ? '#64748b' : '#fff' } },
  }

  return (
    <div
      style={{
        height: '400px',
        background: isLight ? '#f8fafc' : 'rgba(0, 0, 0, 0.2)',
        border: isLight ? '1px solid #e2e8f0' : 'none',
        borderRadius: '12px',
        padding: '15px',
      }}
    >
      <h4
        style={{
          color: isLight ? '#0f172a' : '#fff',
          marginBottom: '15px',
          textAlign: 'center',
          fontWeight: 700,
        }}
      >
        {isVolumeMode ? 'Volume por Família' : 'Faturamento por Família'}
      </h4>
      <ReactApexChart options={options} series={series} type='bar' height='90%' />
    </div>
  )
}
